import script from "./MicroSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./MicroSlider.vue?vue&type=script&setup=true&lang=js"

import "./MicroSlider.vue?vue&type=style&index=0&id=0ecf0fb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecf0fb3"]])

export default __exports__